import { Fragment, ReactElement } from 'react';
import ResearchCohabitationNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-cohabitation';

const ResearchCohabitationNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchCohabitationNotificationCivilStatusShared />
    </Fragment>
  );
};

ResearchCohabitationNotificationCivilStatusPage.displayName =
  'Research Cohabitation Notifications Page component';

export default ResearchCohabitationNotificationCivilStatusPage;
